export const TASK_PAGER_STATE_KEY = "taskPager";

export type TaskPagerEntry = {
  ref: string;
  title: string;
};

// Carried through router state so an opened task can page through the exact list,
// in the exact order, that the advisor was looking at when they clicked in.
export type TaskPagerContext = {
  listName: string;
  listPath: string;
  entries: TaskPagerEntry[];
};
